import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
// import reportWebVitals from './reportWebVitals';

// Disable console logs in production based on environment variable
if (process.env.REACT_APP_DISABLE_CONSOLE === "true") {
  const noop = () => {};
  const methods = ["log", "info", "warn", "error", "debug", "trace"];

  for (let index = 0; index < methods.length; index += 1) {
    const method = methods[index];
    if (typeof console[method] === "function") {
      console[method] = noop;
    }
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
